import * as React from "react"
import { Box } from "@mui/material"
import { IconSeeker } from "@ui-seeker/core"


export default function RatingStars({ rating, sx }) {
    return <Box sx={{ display: 'flex', justifyContent: 'center', ...sx }}>
        { rating > 0 && <IconSeeker icon={rating - 0 < 1 ? 'star-half' : 'star'} color='warning.main' /> }
        { rating > 1 && <IconSeeker icon={rating - 1 < 1 ? 'star-half' : 'star'} color='warning.main' /> }
        { rating > 2 && <IconSeeker icon={rating - 2 < 1 ? 'star-half' : 'star'} color='warning.main' /> }
        { rating > 3 && <IconSeeker icon={rating - 3 < 1 ? 'star-half' : 'star'} color='warning.main' /> }
        { rating > 4 && <IconSeeker icon={rating - 4 < 1 ? 'star-half' : 'star'} color='warning.main' /> }
    </Box> 
}